import { SDKError } from "@smash-sdk/core";
export class GenericError extends SDKError {
}
export class InvalidParameterError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidParameterError";
    }
}
export class UnauthorizedError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "UnauthorizedError";
    }
}
export class PasswordDoesNotMatchError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "PasswordDoesNotMatchError";
    }
}
export class InvalidEmailError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InvalidEmailError";
    }
}
export class OwnerUsageExceededError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "OwnerUsageExceededError";
    }
}
export class AccessorUsageExceededError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "AccessorUsageExceededError";
    }
}
export class ForbiddenError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "ForbiddenError";
    }
}
export class NotFoundError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "NotFoundError";
    }
}
export class InternalServerError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "InternalServerError";
    }
}
export class BadGatewayError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "BadGatewayError";
    }
}
export class GatewayTimeoutError extends GenericError {
    constructor() {
        super(...arguments);
        this.name = "GatewayTimeoutError";
    }
}
export default {
    GenericError,
    InvalidParameterError,
    UnauthorizedError,
    PasswordDoesNotMatchError,
    InvalidEmailError,
    OwnerUsageExceededError,
    AccessorUsageExceededError,
    ForbiddenError,
    NotFoundError,
    InternalServerError,
    BadGatewayError,
    GatewayTimeoutError,
};
